import { http } from '../../../../api/http';
import type { PrecioCliente, SaveBulkRequest } from '../types';

export class PrecioClienteService {
  private static readonly BASE_URL = '/produccion/preciocliente';

  static async getByCliente(idCliente: number): Promise<PrecioCliente[]> {
    try {
      const response = await http.get(`${this.BASE_URL}/cliente/${idCliente}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching precios del cliente:', error);
      throw error;
    }
  }

  static async getByClienteAndTipo(
    idCliente: number,
    tipoProceso: string
  ): Promise<PrecioCliente[]> {
    try {
      const response = await http.get(
        `${this.BASE_URL}/cliente/${idCliente}/${tipoProceso}`
      );
      return response.data;
    } catch (error) {
      console.error('Error fetching precios filtrados:', error);
      throw error;
    }
  }

  static async save(precio: PrecioCliente): Promise<PrecioCliente> {
    try {
      const response = await http.post(`${this.BASE_URL}`, precio);
      return response.data;
    } catch (error) {
      console.error('Error guardando precio:', error);
      throw error;
    }
  }

  static async saveBulk(request: SaveBulkRequest): Promise<{ success: boolean }> {
    try {
      const response = await http.post(`${this.BASE_URL}/bulk`, request);
      return response.data;
    } catch (error) {
      console.error('Error guardando precios en bulk:', error);
      throw error;
    }
  }

  static async delete(id: number): Promise<void> {
    try {
      await http.delete(`${this.BASE_URL}/${id}`);
    } catch (error) {
      console.error(`Error eliminando precio ${id}:`, error);
      throw error;
    }
  }
}
